import React from 'react';

export default function ServiceCard({ icon, tag, title, desc, onLearnMore }) {
  return (
    <article className="svc-card">
      <div className="svc-tag">{tag}</div>
      <div className="svc-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{desc}</p>
      <button className="svc-arrow" onClick={onLearnMore}>
        Get Started →
      </button>
    </article>
  );
}
